export const QHSE_PERMS = {
  DOC_READ: 'READ_QHSE_DOCUMENT',
  DOC_CREATE: 'CREATE_QHSE_DOCUMENT',
  DOC_UPDATE: 'UPDATE_QHSE_DOCUMENT',
  DOC_DELETE: 'DELETE_QHSE_DOCUMENT',
  DOC_VIEW: 'VIEW_QHSE_DOCUMENT',
  DOC_DOWNLOAD: 'DOWNLOAD_QHSE_DOCUMENT',

  CERT_READ: 'READ_QHSE_CERTIFICATE',
  CERT_CREATE: 'CREATE_QHSE_CERTIFICATE',
  CERT_UPDATE: 'UPDATE_QHSE_CERTIFICATE',
  CERT_DELETE: 'DELETE_QHSE_CERTIFICATE',
  CERT_VIEW: 'VIEW_QHSE_CERTIFICATE',
  CERT_DOWNLOAD: 'DOWNLOAD_QHSE_CERTIFICATE',
  CERT_CATEGORY_READ: 'READ_QHSE_CERTIFICATE_CATEGORY',
  CERT_CATEGORY_CREATE: 'CREATE_QHSE_CERTIFICATE_CATEGORY',
  CERT_CATEGORY_UPDATE: 'UPDATE_QHSE_CERTIFICATE_CATEGORY',
  CERT_CATEGORY_DELETE: 'DELETE_QHSE_CERTIFICATE_CATEGORY',

  OFFICE_CERT_READ: 'READ_OFFICE_CERTIFICATE',
  OFFICE_CERT_CREATE: 'CREATE_OFFICE_CERTIFICATE',
  OFFICE_CERT_UPDATE: 'UPDATE_OFFICE_CERTIFICATE',
  OFFICE_CERT_DELETE: 'DELETE_OFFICE_CERTIFICATE',
  OFFICE_CERT_VIEW: 'VIEW_OFFICE_CERTIFICATE',
  OFFICE_CERT_DOWNLOAD: 'DOWNLOAD_OFFICE_CERTIFICATE',

  CERT_NAME_READ: 'READ_QHSE_CERTIFICATE_NAME',
  CERT_NAME_CREATE: 'CREATE_QHSE_CERTIFICATE_NAME',
  CERT_NAME_UPDATE: 'UPDATE_QHSE_CERTIFICATE_NAME',
  CERT_NAME_DELETE: 'DELETE_QHSE_CERTIFICATE_NAME',

  AUDIT_KIND_READ: 'READ_QHSE_AUDIT_KIND',
  AUDIT_KIND_CREATE: 'CREATE_QHSE_AUDIT_KIND',
  AUDIT_KIND_UPDATE: 'UPDATE_QHSE_AUDIT_KIND',
  AUDIT_KIND_DELETE: 'DELETE_QHSE_AUDIT_KIND',

  AUDIT_PLAN_READ: 'READ_QHSE_AUDIT_PLAN',
  AUDIT_PLAN_CREATE: 'CREATE_QHSE_AUDIT_PLAN',
  AUDIT_PLAN_UPDATE: 'UPDATE_QHSE_AUDIT_PLAN',
  AUDIT_PLAN_DELETE: 'DELETE_QHSE_AUDIT_PLAN',

  AUDIT_READ: 'READ_QHSE_AUDIT',
  AUDIT_CREATE: 'CREATE_QHSE_AUDIT',
  AUDIT_UPDATE: 'UPDATE_QHSE_AUDIT',
  AUDIT_DELETE: 'DELETE_QHSE_AUDIT',

  AUDIT_FINDING_READ: 'READ_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_CREATE: 'CREATE_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_UPDATE: 'UPDATE_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_DELETE: 'DELETE_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_SOFT_DELETE: 'SOFT_DELETE_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_ATTACH_UPLOAD: 'UPLOAD_QHSE_AUDIT_FINDING_ATTACHMENT',
  AUDIT_FINDING_ATTACH_DELETE: 'DELETE_QHSE_AUDIT_FINDING_ATTACHMENT',
  AUDIT_FINDING_ATTACH_VIEW: 'VIEW_QHSE_AUDIT_FINDING_ATTACHMENT',
  AUDIT_FINDING_ATTACH_DOWNLOAD: 'DOWNLOAD_QHSE_AUDIT_FINDING_ATTACHMENT',
  AUDIT_FINDING_SUBMIT: 'SUBMIT_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_APPROVE: 'APPROVE_QHSE_AUDIT_FINDING',
  AUDIT_FINDING_REJECT: 'REJECT_QHSE_AUDIT_FINDING',

  INSPECTION_KIND_READ: 'READ_QHSE_INSPECTION_KIND',
  INSPECTION_KIND_CREATE: 'CREATE_QHSE_INSPECTION_KIND',
  INSPECTION_KIND_UPDATE: 'UPDATE_QHSE_INSPECTION_KIND',
  INSPECTION_KIND_DELETE: 'DELETE_QHSE_INSPECTION_KIND',

  INSPECTION_PLAN_READ: 'READ_QHSE_INSPECTION_PLAN',
  INSPECTION_PLAN_CREATE: 'CREATE_QHSE_INSPECTION_PLAN',
  INSPECTION_PLAN_UPDATE: 'UPDATE_QHSE_INSPECTION_PLAN',
  INSPECTION_PLAN_DELETE: 'DELETE_QHSE_INSPECTION_PLAN',

  INSPECTION_READ: 'READ_QHSE_INSPECTION',
  INSPECTION_CREATE: 'CREATE_QHSE_INSPECTION',
  INSPECTION_UPDATE: 'UPDATE_QHSE_INSPECTION',
  INSPECTION_DELETE: 'DELETE_QHSE_INSPECTION',

  INSPECTION_FINDING_READ: 'READ_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_CREATE: 'CREATE_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_UPDATE: 'UPDATE_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_DELETE: 'DELETE_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_SOFT_DELETE: 'SOFT_DELETE_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_ATTACH_UPLOAD: 'UPLOAD_QHSE_INSPECTION_FINDING_ATTACHMENT',
  INSPECTION_FINDING_ATTACH_DELETE: 'DELETE_QHSE_INSPECTION_FINDING_ATTACHMENT',
  INSPECTION_FINDING_ATTACH_VIEW: 'VIEW_QHSE_INSPECTION_FINDING_ATTACHMENT',
  INSPECTION_FINDING_ATTACH_DOWNLOAD: 'DOWNLOAD_QHSE_INSPECTION_FINDING_ATTACHMENT',
  INSPECTION_FINDING_SUBMIT: 'SUBMIT_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_APPROVE: 'APPROVE_QHSE_INSPECTION_FINDING',
  INSPECTION_FINDING_REJECT: 'REJECT_QHSE_INSPECTION_FINDING',

  DEFECT_READ: 'READ_QHSE_DEFECT',
  DEFECT_CREATE: 'CREATE_QHSE_DEFECT',
  DEFECT_UPDATE: 'UPDATE_QHSE_DEFECT',
  DEFECT_DELETE: 'DELETE_QHSE_DEFECT',
  DEFECT_SOFT_DELETE: 'SOFT_DELETE_QHSE_DEFECT',
  DEFECT_SUBMIT: 'SUBMIT_QHSE_DEFECT',
  DEFECT_APPROVE: 'APPROVE_QHSE_DEFECT',
  DEFECT_REJECT: 'REJECT_QHSE_DEFECT',
  DEFECT_CLOSE: 'CLOSE_QHSE_DEFECT',
  DEFECT_OFFICE_REVIEW: 'OFFICE_REVIEW_QHSE_DEFECT',
  DEFECT_ATTACH_UPLOAD: 'UPLOAD_QHSE_DEFECT_ATTACHMENT',
  DEFECT_ATTACH_DELETE: 'DELETE_QHSE_DEFECT_ATTACHMENT',
  DEFECT_ATTACH_VIEW: 'VIEW_QHSE_DEFECT_ATTACHMENT',
  DEFECT_ATTACH_DOWNLOAD: 'DOWNLOAD_QHSE_DEFECT_ATTACHMENT',
  DEFECT_CLOSURE_UPLOAD: 'UPLOAD_QHSE_DEFECT_CLOSURE_EVIDENCE',
  DEFECT_CLOSURE_DELETE: 'DELETE_QHSE_DEFECT_CLOSURE_EVIDENCE',
  DEFECT_CLOSURE_VIEW: 'READ_QHSE_DEFECT_CLOSURE_EVIDENCE',
  DEFECT_CLOSURE_DOWNLOAD: 'DOWNLOAD_QHSE_DEFECT_CLOSURE_EVIDENCE',

  NEAR_MISS_READ: 'READ_QHSE_NEAR_MISS',
  NEAR_MISS_CREATE: 'CREATE_QHSE_NEAR_MISS',
  NEAR_MISS_UPDATE: 'UPDATE_QHSE_NEAR_MISS',
  NEAR_MISS_DELETE: 'DELETE_QHSE_NEAR_MISS',
  NEAR_MISS_SOFT_DELETE: 'SOFT_DELETE_QHSE_NEAR_MISS',
  NEAR_MISS_SUBMIT: 'SUBMIT_QHSE_NEAR_MISS',
  NEAR_MISS_CLOSE: 'CLOSE_QHSE_NEAR_MISS',
  NEAR_MISS_SUPPORT_UPLOAD: 'UPLOAD_QHSE_NEAR_MISS_SUPPORTING',
  NEAR_MISS_SUPPORT_DELETE: 'DELETE_QHSE_NEAR_MISS_SUPPORTING',
  NEAR_MISS_SUPPORT_VIEW: 'VIEW_QHSE_NEAR_MISS_SUPPORTING',
  NEAR_MISS_SUPPORT_DOWNLOAD: 'DOWNLOAD_QHSE_NEAR_MISS_SUPPORTING',

  FORM_TEMPLATE_READ: 'READ_QHSE_FORM_TEMPLATE',
  FORM_TEMPLATE_CREATE: 'CREATE_QHSE_FORM_TEMPLATE',
  FORM_TEMPLATE_UPDATE: 'UPDATE_QHSE_FORM_TEMPLATE',
  FORM_TEMPLATE_DELETE: 'DELETE_QHSE_FORM_TEMPLATE',
  FORM_TEMPLATE_DOWNLOAD: 'DOWNLOAD_QHSE_FORM_TEMPLATE',

  FORM_MENU_READ: 'READ_QHSE_FORM_MENU',
  FORM_MENU_CREATE: 'CREATE_QHSE_FORM_MENU',
  FORM_MENU_UPDATE: 'UPDATE_QHSE_FORM_MENU',
  FORM_MENU_DELETE: 'DELETE_QHSE_FORM_MENU',

  FORM_SUBMENU_READ: 'READ_QHSE_FORM_SUBMENU',
  FORM_SUBMENU_CREATE: 'CREATE_QHSE_FORM_SUBMENU',
  FORM_SUBMENU_UPDATE: 'UPDATE_QHSE_FORM_SUBMENU',
  FORM_SUBMENU_DELETE: 'DELETE_QHSE_FORM_SUBMENU',

  FORM_FIELD_READ: 'READ_QHSE_FORM_FIELD',
  FORM_FIELD_CREATE: 'CREATE_QHSE_FORM_FIELD',
  FORM_FIELD_UPDATE: 'UPDATE_QHSE_FORM_FIELD',
  FORM_FIELD_DELETE: 'DELETE_QHSE_FORM_FIELD',

  FORM_SUBMISSION_READ: 'READ_QHSE_FORM_SUBMISSION',
  FORM_SUBMISSION_CREATE: 'CREATE_QHSE_FORM_SUBMISSION',
  FORM_SUBMISSION_DELETE: 'DELETE_QHSE_FORM_SUBMISSION',

  MANUAL_PLAN_READ: 'READ_QHSE_MANUAL_PLAN',
  MANUAL_PLAN_CREATE: 'CREATE_QHSE_MANUAL_PLAN',
  MANUAL_PLAN_UPDATE: 'UPDATE_QHSE_MANUAL_PLAN',
  MANUAL_PLAN_DELETE: 'DELETE_QHSE_MANUAL_PLAN',
  MANUAL_PLAN_VIEW: 'VIEW_QHSE_MANUAL_PLAN',
  MANUAL_PLAN_DOWNLOAD: 'DOWNLOAD_QHSE_MANUAL_PLAN',

  RISK_READ: 'READ_QHSE_RISK_ASSESSMENT',
  RISK_CREATE: 'CREATE_QHSE_RISK_ASSESSMENT',
  RISK_UPDATE: 'UPDATE_QHSE_RISK_ASSESSMENT',
  RISK_DELETE: 'DELETE_QHSE_RISK_ASSESSMENT',
  RISK_VIEW: 'VIEW_QHSE_RISK_ASSESSMENT',
  RISK_DOWNLOAD: 'DOWNLOAD_QHSE_RISK_ASSESSMENT',

  RISK_LIB_READ: 'READ_QHSE_RISK_LIBRARY',
  RISK_LIB_TASK_CREATE: 'CREATE_QHSE_RISK_LIBRARY_TASK',
  RISK_LIB_TASK_UPDATE: 'UPDATE_QHSE_RISK_LIBRARY_TASK',
  RISK_LIB_TASK_DELETE: 'DELETE_QHSE_RISK_LIBRARY_TASK',
  RISK_LIB_GLOBAL_MANAGE: 'MANAGE_QHSE_RISK_LIBRARY_GLOBAL',

  SAFETY_COMMITTEE_READ: 'READ_QHSE_SAFETY_COMMITTEE_MEETING',
  SAFETY_COMMITTEE_CREATE: 'CREATE_QHSE_SAFETY_COMMITTEE_MEETING',
  SAFETY_COMMITTEE_UPDATE: 'UPDATE_QHSE_SAFETY_COMMITTEE_MEETING',
  SAFETY_COMMITTEE_DELETE: 'DELETE_QHSE_SAFETY_COMMITTEE_MEETING',
  SAFETY_COMMITTEE_SUBMIT: 'SUBMIT_QHSE_SAFETY_COMMITTEE_MEETING',
  SAFETY_COMMITTEE_CLOSE: 'CLOSE_QHSE_SAFETY_COMMITTEE_MEETING',

  WORK_PERMIT_READ: 'READ_QHSE_WORK_PERMIT',
  WORK_PERMIT_CREATE: 'CREATE_QHSE_WORK_PERMIT',
  WORK_PERMIT_UPDATE: 'UPDATE_QHSE_WORK_PERMIT',
  WORK_PERMIT_DELETE: 'DELETE_QHSE_WORK_PERMIT',
  WORK_PERMIT_SUBMIT: 'SUBMIT_QHSE_WORK_PERMIT',
  WORK_PERMIT_APPROVE: 'APPROVE_QHSE_WORK_PERMIT',
  WORK_PERMIT_CLOSE: 'CLOSE_QHSE_WORK_PERMIT',
  WORK_PERMIT_ATTACH_UPLOAD: 'UPLOAD_QHSE_WORK_PERMIT_ATTACHMENT',
  WORK_PERMIT_ATTACH_DELETE: 'DELETE_QHSE_WORK_PERMIT_ATTACHMENT',
  WORK_PERMIT_ATTACH_VIEW: 'VIEW_QHSE_WORK_PERMIT_ATTACHMENT',
  WORK_PERMIT_ATTACH_DOWNLOAD: 'DOWNLOAD_QHSE_WORK_PERMIT_ATTACHMENT',

  MONTH_END_ME_READ: 'READ_QHSE_MONTH_END_ME_CONSUMPTION',
  MONTH_END_ME_CREATE: 'CREATE_QHSE_MONTH_END_ME_CONSUMPTION',
  MONTH_END_ME_UPDATE: 'UPDATE_QHSE_MONTH_END_ME_CONSUMPTION',
  MONTH_END_ME_DELETE: 'DELETE_QHSE_MONTH_END_ME_CONSUMPTION',

  MONTH_END_MACHINERY_READ: 'READ_QHSE_MONTH_END_MACHINERY_STATUS',
  MONTH_END_MACHINERY_CREATE: 'CREATE_QHSE_MONTH_END_MACHINERY_STATUS',
  MONTH_END_MACHINERY_UPDATE: 'UPDATE_QHSE_MONTH_END_MACHINERY_STATUS',
  MONTH_END_MACHINERY_DELETE: 'DELETE_QHSE_MONTH_END_MACHINERY_STATUS',

  MONTH_END_REPORT_READ: 'READ_QHSE_MONTH_END_REPORT',
  MONTH_END_REPORT_CREATE: 'CREATE_QHSE_MONTH_END_REPORT',
  MONTH_END_REPORT_UPDATE: 'UPDATE_QHSE_MONTH_END_REPORT',
  MONTH_END_REPORT_DELETE: 'DELETE_QHSE_MONTH_END_REPORT',
} as const

export type QhsePermission = typeof QHSE_PERMS[keyof typeof QHSE_PERMS]
